import keyMirror from '@kopapro-redux/utils/key-mirror';

export default keyMirror({
  GET_SHIPPING_REGION_REQUEST: null,
  RECEIVED_SHIPPING_REGION: null,
});
